var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.64 49.08C50.6348 46.8419 51.907 44.0535 52.29 41.08C52.913 37.1598 52.7704 33.156 51.87 29.29C50.61 24.96 50.17 22.29 39.37 19.19L39.66 19.79C36.8 18.79 33.96 19.06 32.26 20.41C32.1528 20.4879 32.0524 20.5749 31.96 20.67C31.8533 20.7708 31.7562 20.8812 31.67 21C31.4318 21.2797 31.2364 21.5931 31.09 21.93C29.87 24.41 29.39 28.93 29.54 33.29C26.2672 35.2011 22.8809 36.9109 19.4 38.41L19.7 41.11C19.7 41.11 26.15 41.11 30.18 39.11C29.7131 41.0374 29.6113 43.0352 29.88 45C19.41 50.55 18.07 54.32 20.75 73.28L24.47 75.35C25.47 65.29 25.6 61.49 29.84 57.79C28.54 62.64 28.97 68.89 29.84 78.26L33.56 80.33C37.56 64.27 37.9 62.33 42.86 58.72C43.8164 58.0384 44.7313 57.3004 45.6 56.51C47.43 55.07 48.6 52.7 48.53 51.8C48.6223 51.392 48.6825 50.9774 48.71 50.56L48.64 49.08Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 78.27C21.8 82.27 25.94 87.97 33.52 80.34L29.8 78.27Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.43 17.13C32.82 20.08 35.24 21.25 37.15 21.61C37.1815 21.9768 37.2383 22.341 37.32 22.7C37.63 23.89 44.07 23.78 43.89 21.07C43.69 18.07 47.14 16.07 45.34 12.14C42.34 5.56 36.17 6.66 34.63 12.54C34 14.87 33.43 17.13 33.43 17.13Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.11 13.65C40.18 14.52 41.19 17.94 42.11 16C43.51 13.11 45.36 14.49 44.35 16.68C43.79 17.88 44.96 16.25 44.96 16.25C44.96 16.25 46.49 17.08 46.43 14.93C46.43 13.93 48.03 11.58 46.01 9.11C44.16 6.81 39.38 4.69 40.11 13.65Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47.57 50.38C46.45 58.38 50.96 55.52 50.21 50.72L47.57 50.38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.61 11C37.61 7.82001 34.34 13 34.34 13C34.34 13 28.55 15.38 34.23 8.78001C34.23 8.78001 30.29 6.68001 38.72 5.67001C38.72 5.67001 38.45 3.38001 42.72 5.85001C42.72 5.85001 43.93 4.61001 45.19 6.64001C45.9493 7.79194 46.3013 9.16483 46.19 10.54C46.19 10.54 47.36 11.91 45.71 15.33C44.06 18.75 44.96 14.04 44.96 14.04L41.61 11Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 8.63C34.02 12.4 37.3 12.79 39.71 11.77C39.71 11.77 40.6 18.62 41.83 16.49C43.83 13.12 41.42 8.64001 41.42 8.64001L37.3 8.63Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 73.57L19.72 62.94V32.56L1.6 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.389999 44.29L1.6 44.98V73.57L0.389999 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.389999 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.78 48.82L32.14 56.22L23.53 51.27L36.16 43.87L44.78 48.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 73.29C11.68 78.04 17.42 81.59 24.47 75.36L20.75 73.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 38.41C16.75 36.28 9.3 38.9 19.79 41.08L19.4 38.41Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 25.26L6.63 34.3L17.96 43.56L17.28 34.52L5.95 25.26Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81 7.62C31.81 8.92 30.57 10.62 32.81 11.48C35.05 12.34 34.81 7.62 34.81 7.62Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.71 47.11C43 45.76 42.09 52.54 48.64 49.11L45.71 47.11Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.72 33.22C26.3944 35.1687 22.9474 36.9023 19.4 38.41L19.7 41.11C19.7 41.11 26.63 41.11 30.62 38.91",
    fill: "#252525"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.72 33.22C26.3944 35.1687 22.9474 36.9023 19.4 38.41L19.7 41.11C19.7 41.11 26.63 41.11 30.62 38.91",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.71 47.11C47.26 45.57 47.53 36.58 45.04 33.42L45.71 47.11Z",
    fill: "#252525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.71 47.11C47.26 45.57 47.53 36.58 45.04 33.42",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.07 26.24C31.93 28.75 30.5 31.91 31.58 34.88L30.58 38.88",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante5);
export default __webpack_public_path__ + "static/media/Estudiante5.525c694becbfe2ad8b37d7efe85e12cd.svg";
export { ForwardRef as ReactComponent };